(ns dashboard.entity.document.attribution
  "The principle contract of the dashboard.entity component namespaces are this:
     1. All components will NOT depend on keyword references to subs and events in
        external NSes, but rather receive data as arguments, functions and callbacks.
     2. All internal reliance on the re-frame app DB must be internally contained.
     3. All re-frame app subs and events must NOT be directly referenced by outside
        NSes, but rather via GETTER and SETTER functions - the same is true of internal
        calls - prefer using parameterized functions.
     4. The entity is a UI component that may encapsulate low-level business rules on
        UI controls, but is not responsible for hydrating components with data or entrenched
        references to component namespaces. The UI is customizable, and top-level entities
        should have configurable and interchangable UI elements."
  (:require ["react" :as react]
            [dashboard.common :refer [format-date]]
            [dashboard.components.popup-menu :as popup]
            [dashboard.entity.evidence.fields :as evidence.fields]))

(defn document-attribution
  "Displays the attribution menu in the right panel"
  [{:keys [information-type
           provider
           expiry-date
           responsible-org
           responsible-team
           responsible-person-id]}]
  [:<>
   [:div.mt-2.mb-0
    [:div.title.is-7.my-0.is-info "Informataion Type"]
    (or information-type "<< Set Information >>")]
   [:div.level.mt-2.mb-0
    [:div
     [:div.title.is-7.my-0.is-info "Provider"]
     (or provider "<< Set Provider >>")]
    [:div
     [:div.title.is-7.my-0.is-info "Expires"]
     (or (cond-> expiry-date
           expiry-date
           format-date) "<< No Exipry Date >>")]]
   [:div.mt-2
    [:div.title.is-7.my-0.is-info "Responsibility"]
    (or (when (or responsible-org
                  responsible-team
                  responsible-person-id)
          (->> [responsible-org responsible-team responsible-person-id]
               (remove nil?)
               (interpose " - ")
               (apply str)
               str))
        "<< Set Document Responsibility >>")]])

(defn attribution-editor
  "User controls for document attribution"
  [{:keys [organization-members on-save-attribution] :as attribution-props} filename set-modal-idx]
  [:div.document-viewer-right-sidebar-attribution
   [:h5.title.is-5 "Attribution for " filename]
   [:div.columns
    [:div.column
     [evidence.fields/Information attribution-props]
     [evidence.fields/Provider attribution-props]
     [evidence.fields/ValidatedByAutomation attribution-props]]
    [:div.column
     [evidence.fields/Expiration attribution-props]
     [evidence.fields/Responsibility attribution-props organization-members]]]
   [:div.level-right
    [:button.button.is-flex-grow-1.is-primary
    {:on-click (fn []
                 (on-save-attribution)
                 (set-modal-idx (gensym)))}
    "Save Attribution"]]])

(defn attribution-and-selection
  "Right-hand menu that displays document attribution and user selection tools"
  [{:keys [attribution
           filename
           attribution-props
           is-obsolete]}]
  (let [{:keys [information-type
                provider]} attribution
        [modal-idx set-modal-idx] (react/useState (gensym))]
    [:div.document-viewer-right-sidebar--attribution-and-selection.p-3
     [:div.title.is-5 "Document Attribution"]
     [:f> popup/popup-menu
      {:trigger-content "Configure Document Attribution"
       :trigger-class (when-not (and information-type
                                     provider)
                        "is-info")
       :modal-instance modal-idx
       :suspend-click-to-close true
       :menu-class :document-viewer-right-sidebar-attribution-menu
       :disabled is-obsolete
       :content [:f> attribution-editor attribution-props filename set-modal-idx]}]
     [document-attribution attribution]]))